import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AssetOrderingOptions, GetStakingBannerInfoGQLService, Order } from "@gql/staking";
import { catchError, map } from "rxjs/operators";
import { ExceptionsService } from "@core-services/exceptions.service";
import { InfoService } from "@core-services/info.service";

import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";
import { StakingBannerState } from "@modules/staking/domain/entities/staking-banner-state.model";

@Injectable({
	providedIn: "root"
})
export class StakingBannerRemote {
	public constructor(
		private readonly stakingBannerInfoService: GetStakingBannerInfoGQLService,
		private readonly stakingHelperService: StakingHelperService,
		private readonly exceptionsService: ExceptionsService,
		private readonly infoService: InfoService
	) {}

	public fetchStakingBannerInfo(): Observable<StakingBannerState> {
		return this.stakingBannerInfoService
			.watch(
				{
					filter: { enabled: { equals: true } },
					order: { orderBy: AssetOrderingOptions.YearlyInterest, order: Order.Desc }
				},
				{ fetchPolicy: "network-only" }
			)
			.valueChanges.pipe(
				map(({ data }) => this.stakingHelperService.adaptBannerResponse(data)),
				catchError(this.exceptionsService.extractGqlErrorAndRethrow),
				catchError((error) => {
					this.infoService.handleApiError(error);
					return throwError(error);
				})
			);
	}
}
